/**
 * 网上工商联单点登录模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  {
    name: 'getAccessToken',
    url: '/api/oauth/v1/external/data/auth/accessToken',
    method: 'GET',
  },
  {
    name: 'exchangeToken',
    url: '/api/oauth/v1/external/authorize/token',
    method: 'GET',
  },
]
